var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{class:_vm.className,attrs:{"xmlns":"http://www.w3.org/2000/svg","width":_vm.width,"height":_vm.height,"viewBox":_vm.viewBox,"aria-labelledby":_vm.iconName,"role":"presentation","fill":_vm.color},domProps:{"innerHTML":_vm._s(_vm.SVGChildren)}})
}
var staticRenderFns = []

export { render, staticRenderFns }